import { useEffect, useRef, useState } from 'react';
import { Form, Flex, Divider, message } from 'antd';
import { CustomizationComponent } from '@/pages/Logiblocks/types';
import { CustomButton, CustomInput, CustomSelect } from '@/components';
import { manualTriggerList } from '@/common/static_data';
import { ManualExecutionTriggerFormData } from '../nodeFormTypes';
import manualExecution from '../../../../assets/images/manualExecution.png';

/** The `manualTriggerList` option that offers an in-app execution button. */
const MANUAL_TRIGGER = 'manual';

export const ManualExecutionTriggerCustomization: CustomizationComponent = ({
  nodeData,
  onChange,
  isSidePannelOpen,
  isReadOnly = false,
}) => {
  const [form] = Form.useForm();
  const [showManualSection, setShowManualSection] = useState(false);
  const handleValuesChange = (
    _changedValues: ManualExecutionTriggerFormData,
    allValues: ManualExecutionTriggerFormData
  ) => {
    setShowManualSection(allValues?.external_trigger === MANUAL_TRIGGER);
    onChange({
      manual_execution_trigger: {
        external_trigger: allValues?.external_trigger ?? '',
        execution_keyword: allValues?.execution_keyword ?? '',
      },
    });
  };

  const hasPatchedRef = useRef(false);

  useEffect(() => {
    if (!isSidePannelOpen || hasPatchedRef.current) return;
    const saved = nodeData.manual_execution_trigger;
    if (!saved) return;
    hasPatchedRef.current = true;
    // Listed field by field rather than spread, so the compiler checks the
    // names.
    const formValues: ManualExecutionTriggerFormData = {
      external_trigger: saved.external_trigger,
      execution_keyword: saved.execution_keyword,
    };
    form.setFieldsValue(formValues);
    setShowManualSection(saved.external_trigger === MANUAL_TRIGGER);
  }, [isSidePannelOpen, nodeData, form]);

  useEffect(() => {
    if (!isSidePannelOpen) {
      hasPatchedRef.current = false;
    }
  }, [isSidePannelOpen]);

  return (
    <>
      <Form form={form} layout='vertical' onValuesChange={handleValuesChange}>
        <Flex vertical gap={16}>
          <Form.Item
            className='custom-input form-input-style'
            label='External trigger'
            name='external_trigger'
            style={{ marginBottom: '0px' }}
          >
            <CustomSelect
              height='36px'
              border='0px'
              bgColor='var(--light-gray)'
              textColor='var(--text-secondary)'
              borderRadius='8px'
              lineHeight='38px'
              options={manualTriggerList}
              placeholder='Select...'
              allowClear
              disabled={isReadOnly}
            />
          </Form.Item>
          <Form.Item
            label='Execution keyword'
            name='execution_keyword'
            className='custom-input form-input-style'
            rules={[
              {
                max: 50,
                message: 'Field name cannot exceed 50 characters',
              },
            ]}
          >
            <CustomInput
              placeholder={'Enter keyword'}
              height='36px'
              border='0px'
              bgColor='var(--light-gray)'
              textColor='var(--text-secondary)'
              borderRadius='8px'
              lineHeight='38px'
              disabled={isReadOnly}
            />
          </Form.Item>
          <Divider
            className={'notification-divider'}
            style={{ margin: '4px 0px 0px' }}
          />
          {showManualSection && !isReadOnly && (
            <Flex justify='center' align='center' vertical>
              <img width={180} src={manualExecution} />

              <CustomButton
                text={'Execute workflow'}
                bgColor='#000'
                color='#fff'
                fontSize='14px'
                fontWeight='600'
                height={'48px'}
                width='200px'
                borderRadius='8px'
                padding='0 32px'
                onClick={() => {
                  message.info('Functionality will be implemented soon!');
                }}
              />
            </Flex>
          )}
        </Flex>
      </Form>
    </>
  );
};
